import { AchEntryType } from '@shared/models';

export const achEntryTypeCodes: AchEntryType[] = [
  { value: 'ARC', label: 'Accounts Receivable Entries (ARC)', types: ['pull'], amountLimit: 25000 },
  { value: 'BOC', label: 'Back Office Conversion (BOC)', types: ['pull'], amountLimit: 25000 },
  { value: 'CCD', label: 'Corporate Credit or Debit (CCD)', types: ['pull', 'push'] },
  // { value: 'CIE', label: 'Customer Initiated Entries (CIE)', types: ['push'] },
  // { value: 'CTX', label: 'Corporate Trade Exchange (CTX)', types: ['pull', 'push'] },
  { value: 'POP', label: 'Point of Purchase (POP)', types: ['pull'] },
  { value: 'PPD', label: 'Pre-arranged Payment or Deposit (PPD)', types: ['pull', 'push'] },
  { value: 'RCK', label: 'Re-presented Check Entries (RCK)', types: ['pull'] },
  { value: 'TEL', label: 'Telephone Initiated Entries (TEL)', types: ['pull'] },
  { value: 'WEB', label: 'Internet Initiated/Mobile Entries (WEB)', types: ['pull', 'push'] },
];

export const achPullEntryTypeCodes = [...achEntryTypeCodes.filter((item) => item.types.includes('pull'))];

export const achPushEntryTypeCodes = [...achEntryTypeCodes.filter((item) => item.types.includes('push'))];
